class StickyVideo extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.closeButton = this.querySelector(".section-svideo-close-button");
      this.videoWrapper = this.querySelector(".section-svideo-wrapper");
      this.videoElement = this.videoWrapper.firstElementChild;
      this.appearAfterScroll = this.hasAttribute('appearAfterScroll');
      this.position = this.getAttribute('position');
      this.roundSize = parseInt(this.getAttribute('roundSize'));
      this.enlargedVideoSize = parseInt(this.getAttribute('enlargedVideoSize'));
      this.enlargedVideoSizeMobile = parseInt(this.getAttribute('enlargedVideoSizeMobile'));
      this.handleScrollAppear = this.handleScrollAppear.bind(this);
  
      this.addEventListeners();
      this.applyPositionStyles();
    }
  
    addEventListeners() {
      this.closeButton.addEventListener("click", () => this.handleClickClose());
      this.videoWrapper.addEventListener("click", () => this.handleClickVideo());
      this.videoElement.addEventListener("click", (e) => e.preventDefault()); // Prevent video pause on enlargement 
      this.appearAfterScroll ? window.addEventListener("scroll", this.handleScrollAppear) : this.style.display = "block";
    }
  
    applyPositionStyles() {
      switch (this.position) {
        case 'left':
          this.style.left = "24px";
          break;
        case 'right':
          this.style.right = "24px";
          break;
        default:
          this.style.left = `calc(50% - ${this.roundSize / 2}px)`;
      }
    }
  
    handleScrollAppear() {
      var wHeight = window.innerHeight;
      var y = window.scrollY;
      if (y >= wHeight / 2)
        this.style.display = "block"
    }
  
    // When you click on the mini video to enlarge
    handleClickVideo() {
      if (!this.videoWrapper.classList.contains("section-svideo-enlarged")) {
      if (window.matchMedia("(max-width: 750px)").matches)
        var newWidth = this.enlargedVideoSizeMobile;
      else if (window.matchMedia("(min-width: 1440px)").matches)
        var newWidth = this.enlargedVideoSize - 10;
      else
        var newWidth = this.enlargedVideoSize;
  
      this.style.width = `${newWidth}%`;
      this.style.height = 'auto';
      this.videoWrapper.classList.remove("section-svideo-round");
      this.videoWrapper.classList.add("section-svideo-enlarged");
      this.videoElement.style.width = "100%";
  
      // Video player elements
      this.videoElement.currentTime = 0;
      this.videoElement.setAttribute("controls", "controls")
      this.videoElement.muted = false;
      this.videoElement.volume = 1;
      this.videoElement.removeAttribute("muted");
  
      if (this.position == "center")
        this.style.left = `calc(50% - ${this.enlargedVideoSize / 2}%)`;
      }
    }
  
    // When you click on the close button -> shrink or hide
    handleClickClose() {
      if (this.videoWrapper.classList.contains("section-svideo-enlarged")) {
  
        //Animation from height auto to fixed
        const sectionContainerHeight = this.clientHeight;
        this.style.height = `${sectionContainerHeight}px`;
  
        requestAnimationFrame(() => {
          this.style.height = `${this.roundSize}px`;
        });
  
        this.style.width = `${this.roundSize}px`;
        this.videoWrapper.classList.remove("section-svideo-enlarged");
        this.videoWrapper.classList.add("section-svideo-round");
        this.videoElement.style.removeProperty('width');
  
        // Video player elements
        this.videoElement.removeAttribute("controls");
        this.videoElement.volume = 0;
        this.videoElement.setAttribute("muted", "muted");
  
        if (this.position == "center")
          this.style.left = `calc(50% - ${this.roundSize / 2}px)`;
      }
      else {
        this.style.display = "none";
        window.removeEventListener("scroll", this.handleScrollAppear);
      }
    }
  }
  
  customElements.define('sticky-video', StickyVideo);